export const formatCurrency = amount => {
  if (amount === null || amount === undefined || amount === '') {
    return '$0';
  }

  const numAmount = parseFloat(amount);
  if (isNaN(numAmount)) {
    return '$0';
  }

  return `$${numAmount.toLocaleString('en-US', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  })}`;
};
